import React, { Component } from 'react';
//import logo from './logo.svg';
//import ear from './ear_512x512.png';
import couchcast_logo from './couchcast_logo.png';

import { Link } from "react-router-dom";

import './Broadcast.css';

class Broadcast extends Component {
  render() {

    function handleClick(e) {
      e.preventDefault();
      console.log('The link was clicked.');
      alert("Please wait a moment...");
    }

    function searchBoxChanged(e){
      e.preventDefault();
      var newvalue = e.target.value.toString();
      console.log('The search now says: ',newvalue);
      //document.getElementById("inputBroadcastSearchBox").value = newvalue;
    }

    function focusedInput(e){
      
      if(e.target.value === "Giants vs. Eagles"){
        e.target.value = "";
      }
    }

    return (
      <div className="Broadcast">
        <header className="Broadcast-header">
          <input id="inputBroadcastSearchBox" className="Broadcast-searchBox" onFocus={focusedInput} onChange={searchBoxChanged} defaultValue="Giants vs. Eagles"></input>
            <h1 className="Broadcast-title">You have chosen to broadcast</h1>
        </header>
        <article>
          <img src={couchcast_logo} className="Broadcast-couchcast_logo" alt="couchcast_logo" />
        </article>
        <p className="Broadcast-intro">
          
        </p>
        <footer className="footer">
          <div className="Broadcast-footer">
            <button className="btn-footer" id="startBroadcastInput" onClick={handleClick}>Start Broadcast</button>
          </div>
                    
          <Link to={`/Home/`} className="btn-footer-home back-btn">Back</Link>
        </footer>
      </div>
    );
  }
}

export default Broadcast;



// WEBPACK FOOTER //
// ./src/components/Broadcast.js